module.exports = {"id":"165536","name":"Gustavo Cabral","rating":"80","photo":"./data/images/photos/0/165536.png","club":{"name":"Celta Vigo","logo":"./data/images/clubs/CeltaVigo.png"},"positions":["DC"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/GustavoCabral0.json
// module id = 1673
// module chunks = 0